function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.652 5.628L19.407 7.03l-2.855 1.234.009.262 1.336-.047-.715 2.824v2.242l2.615 6.843 3.652 8.837c-.704.336-1.806.261-2.293-.627l-3.68-6.667-2.022-3.362v-1.917l-.198-.12-.933 1.6-2.282 3.799-3.68 6.667c-.487.888-1.589.963-2.293.627l3.652-8.837 2.615-6.842v-2.243l-.942-3.717-4.53-1.96-4.9-3.082c-.55-.427-.532-.9-.34-1.33L7.98 4.121l4.498 1.03h4.559l4.498-1.03 6.358-2.908c.191.431.21.904-.34 1.331l-4.9 3.083zm-9.909-2.53V1.671a1.67 1.67 0 113.337 0v1.427c-.296.715-.931 1.21-1.668 1.21-.738 0-1.373-.495-1.669-1.21z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "0",
  width: "28",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.652 5.628L19.407 7.03l-2.855 1.234.009.262 1.336-.047-.715 2.824v2.242l2.615 6.843 3.652 8.837c-.704.336-1.806.261-2.293-.627l-3.68-6.667-2.022-3.362v-1.917l-.198-.12-.933 1.6-2.282 3.799-3.68 6.667c-.487.888-1.589.963-2.293.627l3.652-8.837 2.615-6.842v-2.243l-.942-3.717-4.53-1.96-4.9-3.082c-.55-.427-.532-.9-.34-1.33L7.98 4.121l4.498 1.03h4.559l4.498-1.03 6.358-2.908c.191.431.21.904-.34 1.331l-4.9 3.083zm-9.909-2.53V1.671a1.67 1.67 0 113.337 0v1.427c-.296.715-.931 1.21-1.668 1.21-.738 0-1.373-.495-1.669-1.21z",
  fill: "currentColor"
}))));